// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Fv","firstSessionModal_header":"Gv","firstSessionModal_title":"Hv","firstSessionModal_header_tex":"Iv","firstSessionModal_video":"Jv","firstSessionModal_videoContent":"Kv","firstSessionModal_FAQ":"Lv","firstSessionModal_FAQMargin":"Mv","firstSessionModal_FAQTitle":"Nv","firstSessionModal_buttonContainer":"Ov","firstSessionModal_buttonText":"Pv","firstSessionModal_SMSBtn_mob":"Qv"};
    if(module.hot) {
      // 1715632474974
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  